module.exports = __webpack_public_path__ + "static/mock_3-1954ab1aae3fff4d066db5d3d1df47cc.png";